import type { Staff } from "@/lib/authv2/store";
import { ACTION } from "@/lib/auth/actions";
import { hasPermission } from "@/lib/authv2/permissions";

/**
 * Phòng ban chào khách mua thêm. Đây là NỬA THỨ HAI của luật, không phải nới
 * tay cho tiện: nhân sự CSKH online và lễ tân đều mang vai `staff`, mà vai đó
 * cố ý không nằm trong 5 vai được cấp `cskh.aftercare.write`. Bỏ nửa này đi là
 * ẩn nút của đúng những người phải bấm.
 */
const AFTERCARE_DEPTS = new Set(["cskh", "reception"]);

/**
 * Ai được thao tác trên sổ hậu mãi (ghi lần chào, gửi thư, đóng/mở lại).
 *
 * Bản sao đúng cổng backend `auth.AllowOrDept("cskh.aftercare.write", "cskh",
 * "reception")` ở internal/core/aftercare/handler.go — kể cả cách so tên phòng
 * ban: backend chuẩn hoá bằng ToLower(TrimSpace(...)), nên ở đây phải trim rồi
 * mới hạ chữ, không thì hồ sơ có khoảng trắng thừa trượt cổng ở FE mà lại qua
 * được ở BE (nút ẩn oan).
 *
 * Đọc phòng ban theo kiểu phòng thủ như page-access.ts: hồ sơ bị API trả thiếu
 * `department` phải trượt cổng chứ không được ném lỗi trắng màn hình.
 */
export function canWriteAftercare(staff: Staff | null | undefined): boolean {
  if (!staff) return false;
  if (hasPermission(ACTION.CskhAftercareWrite)) return true;
  return AFTERCARE_DEPTS.has((staff.department || "").trim().toLowerCase());
}
